<template>
  <el-dialog :visible.sync="isShowImageDialog" @closed="isShowImageDialog = false" title='图片查看'>
    <div class="imgDiv">
      <img :src='imgBigUrl'>
    </div>
    <div class="imgFiveDiv">
      <img v-for="(itemImg, index) in imgList" :key='index' :src="itemImg" @click="imgBigUrl = itemImg">
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "ViewPicture",
    data () {
      return {
        isShowImageDialog: false, // 查看图片
        imgList:[],
        imgBigUrl: ''
      }
    },
    methods: {
      // 初始化
      init (imgs) {
        this.imgList = imgs;
        this.imgBigUrl = this.imgList[0];
        this.isShowImageDialog = true;
      },
    },
  }
</script>
<style scoped>
.imgDiv {
  width: 100%;
  height: 300px;
  margin: -5px auto;
  text-align: center;
}
.imgDiv>img {
  max-width: 100%;
  height: 100%;
}
.imgFiveDiv {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  overflow: scroll;
}
.imgFiveDiv>img {
  width: 160px;
  height: 100px;
  margin-right: 10px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// ViewPicture.vue?98d97c1e